import angular from 'angular';
import SidebarComponent from './sidebar.component';

export default angular
  .module('verifyApp.sidebar', [])
  .component('sidebar', SidebarComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/reports/sidebar/index.js